module.exports = __webpack_public_path__ + "static/img/member01.4789b44a.png";